import { TableLoader } from 'components/table-loader/table-loader';
import { getAccessToken, useSessionContext } from 'features/auth';
import { useUserContext } from 'features/users';
import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { ROUTES } from './constants';

export const UnauthenticatedRoute = ({
  children,
}: {
  children: ReactElement;
}) => {
  const { isLoggedIn } = useSessionContext();
  // const location = useLocation();
  const { user } = useUserContext();
  const token = getAccessToken();


  if (token && !user) {
    return <div style={{
        display: "flex",
        justifyContent: "center", // horizontal center
        alignItems: "center",     // vertical center
        height: "100vh",          // full viewport height
      }}><TableLoader /></div>; // or redirect/login page
  }

  const origin = ROUTES.DASHBOARD; //location.state?.from?.pathname || ROUTES.HOME;

  if (isLoggedIn) {
    return <Navigate to={origin} replace />;
  }

  return children;
};
